/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Flex, Image } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useRouter } from 'next/router';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import StructuredTextContent from '@components/UI/StructuredTextContent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import MediaEmbedV2 from '@components/Embeds/MediaEmbedV2';

/**
 * Returns the Top Banner Event .
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Content from API
 * @param {string} region - Region of page
 * @param {string} language - Lang of page
 * @returns {ReactElement} TopBannerUym component
 */

const TopBannerUym = ({
  sectionContent,
  region,
  language,
  pageName,
  pageConfig,
  secImage,
}) => {
  const pName = pageConfig?.pageName;
  const isMobile = useMediaQuery({ maxWidth: 960 });
  const styles = {
    default: 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
    'without-bottom-angle': '',
    '': 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
  };
  const router = useRouter();

  return (
    <>
      <Box mb={{md:'90px'}}>
        <Box position={'relative'}>
          <Box
            display={'grid'}
            pos={'relative'}
            h={{ base: '655px', md: 'auto' }}
            background={{
              // base: 'linear-gradient(180deg, rgba(63, 77, 42, 0.05) 20.47%, #3F4D2A 40.62%, #221C08 94.45%)',
              base: 'transparent',
              md: 'transparent',
            }}
            clipPath={{
              base: 'polygon(0 0, 100% 0, 100% 100%, 0 95%)',
              md: 'polygon(0 0, 100% 0, 100% 100%, 0 80%)',
              "2xl": 'polygon(0 0, 100% 0, 100% 100%, 0 85%)'
            }}
            className="topbanner"
          >
            <Box height={'auto'} w={'100%'} background={{ base: 'transparent'}}>
              <Box
                alignItems={'center'}
                display={'flex'}
                h={{
                  base: '665px',
                  md: '662px',
                  "2xl": '640px'
                }}
                backgroundRepeat="no-repeat"
                bgColor={{
                  base: 'transparent',
                  sm: 'transparent',
                  "2xl": 'transparent'
                }}
                backgroundSize={{ base: '125%', md: 'cover', "2xl": '100%' }}
                backgroundPosition={{
                  base: 'top center',
                  sm: 'top center',
                  md: 'center',
                  "2xl": 'right',
                }}
                backgroundImage={{
                  md: sectionContent[0]?.desktopImage?.url,
                  base:
                    sectionContent[0]?.mobileImage?.url ||
                    sectionContent[0]?.desktopImage?.url,
                }}
                mb={{ base: '0', xl: '0' }}
                clipPath={{ base: '', md: styles[sectionContent[0].style] }}
              >
                {!isMobile && (
                  <Flex
                    flexDirection="column"
                    verticalAlign={'center'}
                    p={{
                      base: '7px',
                      md: '0 0 0 4%',
                      "2xl": '0 0 0 370px'
                    }}
                    w={{ base: '100%', sm: '100%', md: '50%' }}
                    maxW={{
                      base: 'auto',
                      md: '50%',
                    }}
                    fontSize={{
                      sm: '44px',
                      base: '30px',
                    }}
                    color={'#28231e'}
                    fontFamily="MuktaMlalar"
                    display={{
                      base: 'none',
                      sm: 'none',
                      lg: 'flex',
                    }}
                    mb="65px"
                  >
                    {secImage?._modelApiKey === 'single_image' && (
                      <Image
                        src={secImage?.image?.url}
                        w={'260px'}
                        h={'50px'}
                        marginBottom={'37px'}
                      />
                    )}
                    {sectionContent[0]?.title === 'MahaShivRatri' ? (
                      <Box as="h1" lineHeight="45px" color="#c7bfad">
                        {sectionContent[0]?.title}
                      </Box>
                    ) : pName == 'hytt' || pName === 'uyirnokkam' ? (
                      <Box
                        as="h1"
                        color={'white'}
                        fontWeight={'600'}
                        fontSize={{ base: '34px', md: '50px' }}
                        letterSpacing={'-3px'}
                        mb={pName === 'uyirnokkam' ? '16px' : ''}
                      >
                        {sectionContent[0]?.title}
                      </Box>
                    ) : (
                      <Box
                        as="h1"
                        lineHeight={pageName === 'ishanga7' ? '116%' : '1.25em'}
                        fontWeight={'350'}
                        fontSize={{ base: '32px', md: '44px' }}
                      >
                        {sectionContent?.title}
                      </Box>
                    )}
                    {render(sectionContent[0].titleSubtext) &&
                      render(sectionContent[0]?.titleSubtext) !== '<p></p>' && (
                        <Box
                          fontSize={{
                            base: '16px',
                            md: language === 'en' ? '30px' : '20px',
                          }}
                          fontFamily="MuktaMlalar"
                          color="#B95C23"
                          mb={{ base: '8px', md: '15px' }}
                          letterSpacing="1px"
                        >
                          {StructuredTextContent(
                            sectionContent[0].titleSubtext
                          )}
                        </Box>
                      )}
                    {render(sectionContent[0]?.description) &&
                      render(sectionContent[0]?.description) !== '<p></p>' && (
                        <Box
                          id="event-description"
                          fontSize={{
                            base:
                              pName === 'uyirnokkam' && language != 'en'
                                ? '18px'
                                : '16px',
                            md: language === 'en' ? '18px' : '22px',
                          }}
                          lineHeight={{ base: '24px', md: '31px' }}
                          fontFamily="MuktaMlalar"
                          color={
                            pName == 'hytt'
                              ? '#E9D5BD'
                              : pName === 'uyirnokkam'
                              ? '#ffffff'
                              : '#333333'
                          }
                          w={'382px'}
                          mb={pName === 'uyirnokkam' ? '16px' : ''}
                        >
                          {StructuredTextContent(sectionContent[0].description)}
                        </Box>
                      )}
                    {render(sectionContent[0]?.closedMessage) &&
                      render(sectionContent[0]?.closedMessage) !== '<p></p>' &&
                      pName === 'uyirnokkam' && (
                        <Box
                          fontSize={{ base: '20px', md: '26px' }}
                          fontFamily="MuktaMlalar"
                          color={'#EB972F'}
                          fontWeight={'500'}
                          mb={pName === 'uyirnokkam' ? '5px' : ''}
                        >
                          {StructuredTextContent(
                            sectionContent[0].closedMessage
                          )}
                        </Box>
                      )}
                    {render(sectionContent[0]?.date) &&
                      render(sectionContent[0]?.date) !== '<p></p>' && (
                        <Box
                          fontSize={{
                            base: '20px',
                            md: '22px',
                          }}
                          fontFamily="MuktaMlalar"
                          fontWeight="500"
                          mt={0}
                          color={
                            pName == 'hytt'
                              ? '#FFAE27'
                              : pName === 'uyirnokkam'
                              ? '#ffffff'
                              : '#B95C23'
                          }
                        >
                          {StructuredTextContent(sectionContent[0].date)}
                        </Box>
                      )}
                    {render(sectionContent[0]?.closedMessage) &&
                      render(sectionContent[0]?.closedMessage) !== '<p></p>' &&
                      pName != 'uyirnokkam' && (
                        <Box
                          fontSize={{ base: '16px', md: '20px' }}
                          fontFamily="MuktaMlalar"
                          color={'#90816E'}
                        >
                          {StructuredTextContent(
                            sectionContent[0].closedMessage
                          )}
                        </Box>
                      )}
                    {sectionContent[0]?.button?.length > 0 && (
                      <Box
                        marginTop="10px"
                        mb={pName === 'uyirnokkam' ? '26px' : ''}
                      >
                        <SimpleButton
                          style={sectionContent[0].button[0]}
                          region={region}
                          lang={language}
                          mb="5px"
                          bgColor="#FFAB43"
                          color="#28231E"
                          _hover={{
                            textDecoration: 'none',
                            bgColor: '#cf4520',
                            color: 'white',
                          }}
                          width={'245px'}
                          height={'50px'}
                          fontWeight="bold"
                          pageName={pageName}
                          pageConfig={pageConfig}
                          fontFamily='MuktaMlalar'
                          className='bannerbtn'
                        />
                      </Box>
                    )}
                    {render(sectionContent[0]?.bottomText) &&
                      render(sectionContent[0]?.bottomText) !== '<p></p>' && (
                        <Box
                          id="donate-button"
                          fontSize={{
                            base: '16px',
                            md: language === 'en' ? '16px' : '12px',
                          }}
                          fontFamily="MuktaMlalar"
                          mb="10px"
                          mt="10px"
                          lineHeight="160%"
                          color={pName == 'hytt' ? '#ffffff' : ''}
                        >
                          {StructuredTextContent(sectionContent[0].bottomText)}
                        </Box>
                      )}

                    {sectionContent[0]?.secondaryCta?.length > 0 && (
                      <Box marginTop="5px">
                        <SimpleButton
                          style={sectionContent[0].secondaryCta[0]}
                          region={region}
                          lang={language}
                          bgColor="#FFAB43"
                          color="#28231E"
                          fontWeight="bold"
                          mb="5px"
                          minW={'200px'}
                          textAlign="center"
                          mt="0"
                          pageConfig={pageConfig}
                          fontFamily='MuktaMlalar'
                        />
                      </Box>
                    )}
                  </Flex>
                )}

              {isMobile && (
                <Flex
                  display={{
                    base: 'flex',
                    sm: 'flex',
                    md: 'flex',
                    lg: 'none',
                    xl: 'none',
                  }}
                  flexDirection="column"
                  verticalAlign={'center'}
                  w={{ base: '100%', sm: '80%', md: '96%', lg: '50%' }}
                  p={{ base: '0px 12px 20px 12px', md: '30px' }}
                  fontSize={{
                    base: '34px',
                  }}
                  color={'#28231e'}
                  fontFamily="MuktaMlalar"
                  fontWeight={'700'}
                  marginTop="270px"
                >
                  <Box
                    as="h1"
                    fontSize={{
                      base: '34px',
                      md: '50px',
                    }}
                    lineHeight={{
                      base: '50px',
                      md: '87px',
                    }}
                    fontWeight={'600'}
                    color={'white'}
                  >
                    {sectionContent[0]?.title}
                  </Box>
                  {sectionContent[0].titleSubtext && (
                    <Box
                      fontSize={{ base: '18px' }}
                      fontFamily="MuktaMlalar"
                      lineHeight={'24px'}
                      color="#ffffff"
                      fontWeight={'400'}
                      letterSpacing={'-1'}
                    >
                      {StructuredTextContent(sectionContent[0].titleSubtext)}
                    </Box>
                  )}
                  {render(sectionContent[0]?.description) &&
                    render(sectionContent[0]?.description) !== '<p></p>' && (
                      <Box
                        id="event-description"
                        fontSize={{ base: '18px', md: '22px' }}
                        fontFamily="MuktaMlalar"
                        lineHeight={'24px'}
                        color={'#ffffff'}
                        fontWeight={'normal'}
                        m="0 0 4px 0"
                      >
                        {StructuredTextContent(sectionContent[0].description)}
                      </Box>
                    )}
                  {render(sectionContent[0]?.closedMessage) &&
                    render(sectionContent[0]?.closedMessage) !== '<p></p>' && (
                      <Box
                        fontSize={{ base: '20px !important', md: '20px' }}
                        fontFamily="MuktaMlalar"
                        className={'closeMessage'}
                        fontWeight={'normal'}
                        m="5px 0 0 0"
                      >
                        {StructuredTextContent(sectionContent[0].closedMessage)}
                      </Box>
                    )}
                  {render(sectionContent[0]?.date) &&
                    render(sectionContent[0]?.date) !== '' && (
                      <Box
                        fontSize={{ base: '20px', md: '22px' }}
                        fontFamily="MuktaMlalar"
                        fontWeight="500"
                        my={0}
                        color={'#ffffff'}
                      >
                        {StructuredTextContent(sectionContent[0].date)}
                      </Box>
                    )}
                  {sectionContent[0]?.button?.length > 0 && (
                    <Box marginTop={'0px'} h="auto">
                      <SimpleButton
                        style={sectionContent[0].button[0]}
                        region={region}
                        lang={language}
                        mb={'0'}
                        mt={'10px'}
                        height={{base:'50px', md:'50px'}}
                        width="245px"
                        bgColor="#FFAB43"
                        color="#28231E"
                        fontSize="18px"
                        fontWeight="700"
                        pageConfig={pageConfig}
                        fontFamily='MuktaMlalar'
                        className="bannerbtn"
                      />
                    </Box>
                  )}
                  {sectionContent[0]?.secondaryCta?.length > 0 && (
                    <Box mt="0">
                      <SimpleButton
                        style={sectionContent[0].secondaryCta[0]}
                        region={region}
                        lang={language}
                        bgColor="#FFAB43"
                        color="#28231E"
                        fontWeight="bold"
                        mb="15px"
                        width={'245px'}
                        textAlign="center"
                        pageName={pageName}
                        pageConfig={pageConfig}
                        fontFamily='MuktaMlalar'
                      />
                    </Box>
                  )}
                </Flex>
              )}
              </Box>
            </Box>
          </Box>
          <Box
            className="Quotes"
            background="linear-gradient(180deg, #FEF8E2 0%, rgba(254, 248, 226, 0) 94.38%)"
            pt="150px"
            marginTop="-145px"
          >
            <Box
              bgImage={{
                base: '',
                md: `url('${sectionContent[5]?.image?.url}')`,
              }}
              bgRepeat={'no-repeat'}
              bgPosition={'0px left'}
              bgBlendMode="overlay"
              alignContent={'center'}
              alignItems={'center'}
              justifyItems={'center'}
              textAlign={'center'}
            >
              <Image
                src={sectionContent[3]?.image?.url}
                marginBottom={'10px'}
              />
              <Box
                width={{ base: '90%', md: '662px' }}
                lineHeight={{ base: '33px', md: '42px' }}
                fontSize={{ base: '18px', lg: '22px' }}
                color="#28231e"
                textAlign={'center'}
                m="0 auto"
              >
                <StructuredTextParser
                  str={render(sectionContent[1]?.body)}
                  region={region}
                  lang={language}
                  className="quotes_text"
                  textAlign={'center'}
                />
                <Box mb={{ base: '20px', md: '30px' }}>
                  <Image
                    src={sectionContent[4]?.image?.url}
                    marginBottom={'10px'}
                  />
                </Box>
                <Box>
                  <Image
                    src={sectionContent[2]?.image?.url}
                    marginBottom={'37px'}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box as="div">
          <Box
            width={{ base: '90%', md: '760px' }}
            lineHeight={{ base: '34px', md: '42px' }}
            fontSize={{ base: '20px', lg: '26px' }}
            color="#28231e"
            textAlign={'center'}
            m="0 auto 30px auto"
          >
            <StructuredTextParser
              str={render(sectionContent[6].body)}
              region={region}
              lang={language}
              color={'#02026B'}
              className="ParaText1"
              textAlign={'center'}
            />
          </Box>
          <Box
            width={{ base: '90%', md: '760px' }}
            lineHeight={{ base: '32px', md: '34px' }}
            fontSize={{ base: '18px', lg: '22px' }}
            color="#28231e"
            textAlign={'center'}
            m="0 auto"
          >
            <StructuredTextParser
              str={render(sectionContent[7].body)}
              region={region}
              lang={language}
              textAlign={'center'}
              className="ParaText2"
            />
          </Box>
          <Box borderRadius={{ base: '8px', md: '' }}>
            <MediaEmbedV2
              sectionContent={sectionContent[8]}
              maxW={{ base: '90%', md: '762px' }}
              margin={{ base: '40px auto 40px auto !important', md: '45px auto 50px' }}
              width={{ base: '100%', md: '762px' }}
              height={{base:'100%',md:'413px'}}
              className="video_content"
              bgcolor={'#FFAE27'}
              pageName="uyirnokkam"
            />
          </Box>
        </Box>
        <style>
          {`
            .ParaText1 p {
              font-family: 'MuktaMlalar';
              font-size: 26px;
              line-height: 42px;
              font-weight: 600;
            }
            .ParaText2 p {
              font-family: 'MuktaMlalar';
              font-size: 22px;
              line-height: 34px;
              color: #000000;
            }
            #uym-faq-section {
              margin-bottom: 30px;
            }
            
            #event-description h2 {
              font-family: 'MuktaMlalar';
              font-size: 27px;
              color: #28231e;
              font-weight: 'bold';
              padding: 15px 0 0 0;
            }
            #donate-button a {
              color:#cf4520;
              text-decoration:underline;
            }
            #donate-button a:hover {
              text-decoration:none;
            }
            .closeMessage {
              color: #EB972F;
              margin-top: 5px;
              font-size: 12px;
              font-weight: 500;
            }
            .closeMessage a {
              color: #cf4824;
            }
            .hytt-closemessage {
              color:#90816E;
              margin-top: 5px;
              font-size: 16px;
            }
            .quotes_text p {
              font-family: 'MuktaMlalar';
              font-size: 22px;
              line-height: 43px;
            }
            .video_content .play_btn {
              width: 75px;
              height: 75px;
            }
            #embed-vid {
              height: 413px !important;
            }
            .bannerbtn {
              max-height: 50px;
              padding: 11px 29px;
            }
            @media (max-width: 768px) {
              .quotes_text p {
                font-size: 18px;
                font-weight: 400;
                line-height: 34px;
              }
              .ParaText1 p {
                font-size: 20px;
                font-weight: 500;
                line-height: 34px;
              } 
              .ParaText2 p {
                font-size: 18px;
                line-height: 32px;
              }
              #event-description h2 {
                font-size: 20px;
              }
              #embed-vid {
                height: 177px !important;
                margin: 30px auto 50px auto;
              }
              .video_content .play_btn {
                width: 33px;
                height: 33px;
              }
              .bannerbtn {
               padding: 11px 29px;
              }
            }
          `}
        </style>
      </Box>
    </>
  );
};

export default TopBannerUym;